/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable no-nested-ternary */
/* eslint-disable import/no-unresolved */
import { useLazyQuery, useReactiveVar } from '@apollo/client';
import { saveAs } from 'file-saver';
import { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import {
    getPreviousBatchVar, isFileUploadingVar, showBatchAlertVar, showReportMenuVar,
    tenantIdVar, leftNavigationItemsVar, moduleIdVar, currentLeftMenuVar,
} from 'Apollo/config';
import {
    GET_BATCH_TESTS_FOR_FFIEC009, GET_FFIEC009_DOWNLOADED_RESULT, GET_LATEST_BATCH_FOR_FFIEC009, GET_QUARTER_FILTERED_BATCH_TEST_FOR_FFIEC009, GET_SUMMARY_QUARTER_FOR_FFIEC009,
} from 'Apollo/Queries/Rules/FFIEC009Results';
import { ModuleEnum } from 'constants';
import DiagnosticResultsUI from 'views/DiagnosticResults/components';
import crossReportImg from 'assets/images/cross-report-black.svg';
import StatusComponent from '../../../DiagnosticResults/components/StatusComponent';

const listItems = [
    [
        <i key={1} className="appkiticon icon-bar-chart-outline" style={{ fontSize: '1.5rem', color: '#464646', top: '100px' }} />,
        <span key={2} className="a-nav-item-text" style={{ fontSize: '0.7rem', color: '#464646' }}>Data Reconciliation</span>,
    ],
    [
        <i key={1} className="appkiticon icon-ticket-outline" style={{ fontSize: '1.5rem', color: 'white', top: '100px' }} />,
        <span key={2} className="a-nav-item-text" style={{ fontSize: '0.7rem' }}>Rule Engine</span>,
    ],
    [
        <img
            key={1}
            src={crossReportImg}
            alt="Cross Report"
            style={{
                width: '30.84px', height: '25px', top: '100px',
            }}
        />,
        <span key={2} className="a-nav-item-text" style={{ color: '#464646', fontSize: '0.7rem' }}>Cross Report Validation</span>,
    ],
    [
        <i key={1} className="appkiticon icon-grow-revenue-outline" style={{ fontSize: '1.5rem', color: '#464646', top: '100px' }} />,
        <span key={2} className="a-nav-item-text" style={{ color: '#464646', fontSize: '0.7rem' }}>Trend Analytics</span>,
    ],
];

const FFIEC009LandingPage = () => {
    const pageName = 'FFIEC009 Diagnostic Results';
    const history = useHistory();
    const location = useLocation();
    const [regulation, setRegulation] = useState(location.state.regulation);
    const isFileUploading = useReactiveVar(isFileUploadingVar);
    const showBatchAlert = useReactiveVar(showBatchAlertVar);
    const [selectedQuarter, setSelectedQuarter] = useState('');
    const [oneTimeFalg, setOneTimeFalg] = useState(true);
    const getPreviousBatch = useReactiveVar(getPreviousBatchVar);
    const [showSuccessAlert, setShowSuccessAlert] = useState(false);
    const [queryError, setQueryError] = useState(false);
    const tenantId = useReactiveVar(tenantIdVar);

    /* Apollo lazy query to fetch batch tests result  */
    const [getBatchTestData, { loading: isLoading, data }] = useLazyQuery(GET_BATCH_TESTS_FOR_FFIEC009, {
        variables: {
            input: {
                pageSize: 10000,
                pageNumber: 1,
                getPreviousBatch,
                tenantId,
            },
        },
        fetchPolicy: 'no-cache',
    });

    /* Apollo lazy query to fetch getCurrentStatusOfLatestBatch  */
    const [getCurrentStatusOfLatestBatch, {
        data: { getCurrentStatusOfLatestBatchForFFIEC009 = {} } = {}, stopPolling, error: getCurrentStatusOfLatestBatchError,
    }] = useLazyQuery(GET_LATEST_BATCH_FOR_FFIEC009, {
        variables: {
            input: {
                tenantId,
            },
        },
        pollInterval: 20000,
        fetchPolicy: 'no-cache',
    });

    /* Apollo query to fetch batch tests result  */
    const [getQuarterFilteredData, filteredBatchTests] = useLazyQuery(GET_QUARTER_FILTERED_BATCH_TEST_FOR_FFIEC009, {
        fetchPolicy: 'no-cache',
    });

    /* Apollo query to fetch quarters  */
    const [getSummaryQuarter, summaryQuartersData] = useLazyQuery(GET_SUMMARY_QUARTER_FOR_FFIEC009, {
        variables: {
            input: {
                tenantId,
            },
        },
        fetchPolicy: 'no-cache',
    });

    /* Apollo query to download batch test result  */
    const [getDownloadedResult, { loading: isDownloading, data: { getFFIEC009SummaryDetailsForDownload = {} } = {} }] = useLazyQuery(GET_FFIEC009_DOWNLOADED_RESULT, {
        fetchPolicy: 'no-cache',
    });

    /* status component fetched from diagonstic result folder */
    const getSpanStyle = status => (
        <StatusComponent
            status={status}
        />
    );

    /* Column configuration for batch test summary table */
    const columns = [
        {
            Header: 'Rule ID',
            accessor: 'ruleId',
            minWidth: 70,
            resizable: true,
            sortable: true,
        },
        {
            Header: 'Schedule / Part',
            accessor: 'schedule',
            minWidth: 150,
            resizable: true,
            sortable: true,
        },
        {
            Header: 'MDRM',
            accessor: 'mdrmNumber',
            minWidth: 130,
            resizable: true,
            sortable: true,
        },
        {
            Header: 'Associated rule',
            accessor: 'editTest',
            minWidth: 290,
            resizable: true,
            sortable: true,
        },
        {
            Header: 'Enabled Y/N',
            accessor: 'isActive',
            minWidth: 110,
            resizable: true,
            sortable: true,
            Cell: row => {
                const { original: { isActive } } = row;
                return isActive === 'Y' ? <span style={{ paddingLeft: '40%' }}>Y</span> : <span style={{ paddingLeft: '40%' }}>N</span>;
            },
        },
        {
            Header: 'Aggregate Rule',
            accessor: 'aggregateRule',
            minWidth: 120,
            resizable: true,
            sortable: true,
            Cell: row => {
                const { original: { aggregateRule } } = row;
                return aggregateRule ? <span style={{ paddingLeft: '40%' }}>Y</span> : <span style={{ paddingLeft: '40%' }}>N</span>;
            },
        },
        {
            Header: 'Test status',
            accessor: 'testRunStatus',
            minWidth: 90,
            resizable: true,
            sortable: true,
            Cell: row => {
                const { original: { testRunStatus } } = row;
                return getSpanStyle(testRunStatus);
            },
        },
    ];

    /* Breadcrumb items configuration */
    const breadcrumbItems = [
        {
            link: '',
            value: (
                <span
                    className="appkiticon icon-home-fill font-16"
                    onClick={
                        () => {
                            showReportMenuVar(false);
                            history.push('/');
                            leftNavigationItemsVar([]);
                            moduleIdVar(null);
                        }
                    }
                    role="presentation"
                />
            ),
        },
        {
            link: '',
            value: <span className="a-breadcrumb-item-text">FFIEC009 Diagnostic Results</span>,
        },
    ];

    /* Method for sidebar navigation */
    const onNavigate = () => {
        // method for sidebar navigation
    };

    /* Navigates to result page of specific rule */
    const uploadReport = () => {
        history.push(
            {
                pathname: '/UploadReport',
            },
        );
    };

    /** Calls getDownloadedResult() */
    const downloadResult = async () => {
        const quarter = Math.floor(selectedQuarter.getMonth() / 3 + 1);
        const year = selectedQuarter.getFullYear();
        const qtrValue = `q${quarter}_${year}`;
        await getDownloadedResult({
            variables: {
                input: {
                    tenantId,
                    period: qtrValue,
                },
            },
        });
    };

    /* Navigates to result page of specific rule */
    const onNavigateToResult = row => {
        history.push(
            {
                pathname: '/FFIEC009Result',
                state: {
                    // tenantId,
                    // regulator_id: regulationId,
                    batchId: row.batchId,
                    ruleId: row.ruleId,
                    period: row.period,
                    // regulation,
                },
            },
        );
    };

    const getLatestBatch = () => {
        stopPolling();
        setOneTimeFalg(true);
        setShowSuccessAlert(false);
        getPreviousBatchVar(false);
    };

    useEffect(() => {
        leftNavigationItemsVar(listItems);
        currentLeftMenuVar(ModuleEnum.RULEENGINE);
    }, []);

    /* Side effect when location state updates */
    useEffect(() => {
        setRegulation(location.state.regulation);
        showReportMenuVar(true);
    }, [location]);

    /* Side effect when getPreviousBatch changed */
    useEffect(async () => {
        getBatchTestData();
        getSummaryQuarter();
        if (getPreviousBatch === true) {
            getCurrentStatusOfLatestBatch();
        }
    }, [getPreviousBatch]);

    /* Side effect when getBatchTestsForFFIEC009 changed */
    useEffect(() => {
        if (data && data.getBatchTestsForFFIEC009) {
            const qtrValue = data.getBatchTestsForFFIEC009[0].period;
            const quarter = qtrValue.split('_')[0];
            const year = qtrValue.split('_')[1];
            let date;
            switch (quarter) {
                case 'q1':
                    date = new Date(year, 0, 1);
                    break;
                case 'q2':
                    date = new Date(year, 3, 1);
                    break;
                case 'q3':
                    date = new Date(year, 6, 1);
                    break;
                case 'q4':
                    date = new Date(year, 9, 1);
                    break;
                default:
                    break;
            }
            setSelectedQuarter(date);
        } else {
            setSelectedQuarter('');
        }
    }, [data]);

    /* Side effect when getCurrentStatusOfLatestBatchForFFIEC009 changed */
    useEffect(() => {
        const isCurrentStatusForLatestBatchAvailable = getCurrentStatusOfLatestBatchForFFIEC009.length > 0 && Object.keys(getCurrentStatusOfLatestBatchForFFIEC009[0]).length > 0;

        if (isCurrentStatusForLatestBatchAvailable
            && ((getCurrentStatusOfLatestBatchForFFIEC009[0]).batchRunStatus === 'Completed'
                || (getCurrentStatusOfLatestBatchForFFIEC009[0]).batchRunStatus === 'Failed')) {
            showBatchAlertVar(false);
            stopPolling();
        }
        if (isCurrentStatusForLatestBatchAvailable
            && getCurrentStatusOfLatestBatchForFFIEC009[0].batchRunStatus === 'Completed') {
            setShowSuccessAlert(true);
        }
    }, [getCurrentStatusOfLatestBatchForFFIEC009, stopPolling]);

    /* Side effect when getCurrentStatusOfLatestBatchError changed */
    useEffect(() => {
        if (getCurrentStatusOfLatestBatchError) {
            stopPolling();
            setQueryError(true);
            showBatchAlertVar(false);
        }
    }, [getCurrentStatusOfLatestBatchError, stopPolling]);

    /* Side effect when selectedQuarter changed */
    useEffect(() => {
        if (selectedQuarter !== '' && !getPreviousBatch) {
            const quarter = Math.floor(selectedQuarter.getMonth() / 3 + 1);
            const year = selectedQuarter.getFullYear();
            const qtrValue = `q${quarter}_${year}`;
            getQuarterFilteredData({
                variables: {
                    input: {
                        period: qtrValue,
                        pageNumber: 1,
                        pageSize: 500,
                        tenantId,
                    },
                },
            });
            setOneTimeFalg(false);
        }
    }, [selectedQuarter, getPreviousBatch]);

    /* Side effect when getFFIEC009SummaryDetailsForDownload changed */
    useEffect(() => {
        if (getFFIEC009SummaryDetailsForDownload && getFFIEC009SummaryDetailsForDownload.length > 0) {
            const json = getFFIEC009SummaryDetailsForDownload;
            const fields = Object.keys(json[0]);
            const replacer = (key, value) => (value === null ? '' : value);
            let csv = json.map(row => fields.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','));
            csv.unshift(fields.join(','));
            csv = csv.join('\r\n');
            const blob = new Blob([csv], { type: 'text/csv' });
            saveAs(blob, `${regulation}_result.csv`);
        }
    }, [getFFIEC009SummaryDetailsForDownload]);

    return (
        <DiagnosticResultsUI
            pageName={pageName}
            columns={columns}
            summaryQuartersData={summaryQuartersData}
            selectedQuarter={selectedQuarter}
            setSelectedQuarter={setSelectedQuarter}
            commonData={oneTimeFalg ? data && data.getBatchTestsForFFIEC009 : filteredBatchTests.data && filteredBatchTests.data.getFFIEC009BatchTestsByQuarter}
            breadcrumbItems={breadcrumbItems}
            onNavigate={onNavigate}
            uploadReport={uploadReport}
            downloadResult={downloadResult}
            isDownloading={isDownloading}
            onNavigateToResult={onNavigateToResult}
            isBatchTestDataLoading={isLoading}
            isFileUploading={isFileUploading}
            latestBatch={getCurrentStatusOfLatestBatchForFFIEC009}
            getPreviousBatch={getPreviousBatch}
            showSuccessAlert={showSuccessAlert}
            getLatestBatch={getLatestBatch}
            showBatchAlert={showBatchAlert}
            queryError={queryError}
        />
    );
};

export default FFIEC009LandingPage;
